module.exports = __webpack_public_path__ + "img/excel.cd9cd423.svg";